import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cartConfig: {},
  config: {},
};

const axiosConfigSlice = createSlice({
  name: "axiosConfig",
  initialState,
  reducers: {
    setCartConfig: (state, action) => {
      state.cartConfig = { ...state.cartConfig, ...action.payload };
    },
    setConfig: (state, action) => {
      state.config = { ...state.config, ...action.payload };
    },
    resetAxiosConfig: (state) => {
      state.cartConfig = {};
      state.config = {};
    },
  },
});

export const axiosConfigReducer = axiosConfigSlice.reducer;

export const { setCartConfig, setConfig, resetAxiosConfig } =
  axiosConfigSlice.actions;
